/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { JobChangeOrderRestService, JobListFilterDto } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';

import { JobListItem } from './job.model';
import { FilterNames, FilterRestService } from '@gh/builder-shared';

@Injectable()
export class JobCoJobListBusinessService implements InitViewService {
  constructor(private jobCoRest: JobChangeOrderRestService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('jobCoList'),
      filter:  this.filterService.get(FilterNames.jobCoList),
    };
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItem> {
    return this.jobCoRest.findAllAsDataSource(filter);
  }
}
